import apiCrud from '../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/staffs/partner-staffs`;
export const modelName = 'partner-staff';

export default {
  ...apiCrud({ baseUri, modelName }),
};
